import React from "react";

function SvgIcMapPoi134(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M21.663 22.072c.9 0 1.009-1.206 1.009-2.07 0-.89-.081-2.07-1.01-2.07-.863 0-.99 1.205-.99 2.07 0 .54.054 1.053.199 1.44.144.388.396.63.792.63M24 25c1.054 0 1.918.816 1.995 1.85L26 27H6c0-1.054.816-1.918 1.85-1.995L8 25h16zm-2.337-8.095c1.846 0 2.494 1.54 2.494 3.097 0 1.585-.748 3.096-2.494 3.096-.46 0-.855-.089-1.17-.26-.936-.523-1.306-1.63-1.306-2.836 0-1.548.747-3.097 2.476-3.097zm-4.995 0c.675 0 1.098.117 1.485.252l-.054 1.152c-.387-.189-.711-.34-1.323-.34-1.1 0-1.64.917-1.64 2.033 0 1.01.352 2.035 1.433 2.035a.94.94 0 00.432-.09V20.56h-.694v-1.008h2.008v3.232c-.55.243-1.323.314-1.908.314-1.873 0-2.755-1.25-2.755-3.096 0-1.819 1.17-3.097 3.016-3.097zm-6.75.09l1.485 4.375v-4.375h1.215V23h-1.845l-1.476-4.366V23H8.08v-6.005h1.837zM15.5 4a.5.5 0 01.492.41L16 4.5V5h6v4h-6v1.118l10 4.883v1H6v-1l9-4.612V4.5a.5.5 0 01.5-.5z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi134;
